import { render, staticRenderFns } from "./homeworkanswer.vue?vue&type=template&id=53406bb4&scoped=true&"
import script from "./homeworkanswer.vue?vue&type=script&lang=js&"
export * from "./homeworkanswer.vue?vue&type=script&lang=js&"
import style0 from "./homeworkanswer.vue?vue&type=style&index=0&id=53406bb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53406bb4",
  null
  
)

export default component.exports